import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

/**
 * @deprecated
 * Use an icon from @bridebook/aura instead.
 */
const IconShare = ({ id, color, width = 43, style, ...restProps }: IProps) => {
  const viewBoxWidth = 43;
  const viewBoxHeight = 49;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        fillRule="evenodd"
        d="M34.491 4.04a3.797 3.797 0 0 0-3.794 3.791c0 2.09 1.702 3.79 3.794 3.79s3.794-1.7 3.794-3.79A3.797 3.797 0 0 0 34.49 4.04M17.692 34.55a11.653 11.653 0 0 1-5.977 1.641C5.255 36.191 0 30.941 0 24.486c0-6.453 5.256-11.704 11.715-11.704 2.326 0 4.495.68 6.32 1.852l8.864-4.856a7.811 7.811 0 0 1-.245-1.947C26.654 3.513 30.169 0 34.49 0c4.322 0 7.837 3.513 7.837 7.831 0 4.317-3.515 7.83-7.837 7.83a7.818 7.818 0 0 1-5.606-2.364l-7.746 4.243a11.636 11.636 0 0 1 2.292 6.946 11.64 11.64 0 0 1-2.458 7.167l8.555 4.08a7.818 7.818 0 0 1 5.635-2.393c4.322 0 7.837 3.513 7.837 7.83 0 4.318-3.515 7.83-7.837 7.83-4.322 0-7.838-3.512-7.838-7.83 0-.655.081-1.292.234-1.9l-9.672-4.613a2.045 2.045 0 0 1-.195-.106zm17.47 2.83a3.797 3.797 0 0 0-3.793 3.79c0 2.09 1.702 3.79 3.794 3.79s3.793-1.7 3.793-3.79a3.797 3.797 0 0 0-3.793-3.79zM11.716 16.82c-4.23 0-7.671 3.439-7.671 7.665 0 4.227 3.441 7.666 7.671 7.666s7.672-3.439 7.672-7.666c0-4.226-3.441-7.665-7.672-7.665z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconShare;
